import { Box, Button, IconButtonProps, Text, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { RiMoonLine, RiSunLine } from "react-icons/ri";

interface IColorModeToggleProps extends IconButtonProps {
    onToggled?: (lang: "dark" | "light") => void;
}

export function ColorModeToggle({ onToggled }: IColorModeToggleProps) {
    const { t } = useTranslation();
    const { colorMode, toggleColorMode } = useColorMode();

    const toggle = () => {
        onToggled?.(colorMode === "light" ? "dark" : "light");
        toggleColorMode();
    };

    return (
        <Button
            variant="link"
            onClick={() => toggle()}
            color={useColorModeValue("gray.900", "gray.50")}
            justifyContent="flex-start"
            _focus={{
                color: useColorModeValue("gray.900", "gray.50"),
            }}
            _hover={{
                textDecoration: "none",
            }}
        >
            <Box as="span" display="inline-flex" mr={2} fontSize="20px" aria-hidden>
                {colorMode === "light" ? <RiSunLine /> : <RiMoonLine />}
            </Box>
            <Text fontSize="sm" fontWeight={"medium"}>
                {colorMode === "light" ? t("colorMode.dark") : t("colorMode.light")}
            </Text>
        </Button>
    );
}
